import { allActiveAccountsSelector } from 'store/account/selectors';
import { profileErrorSelector, profileIsFetchingSelector } from 'store/profile/selectors';

export const patientsFetchingSelector = profileIsFetchingSelector;
export const patientsErrorSelector = profileErrorSelector;
export const patientsDataSelector = allActiveAccountsSelector;
